<template>
	<div class="basic_wrap">
        <iframe 
            src="https://chat.renewable-energy.xyz" 
            class="external-link"
            frameborder="0"
            allowfullscreen
            scrolling="yes">
        </iframe>
	</div>
</template>

<script>
	export default {
		name: "activity",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				data: {},
				show_ver:false,
			}
		},
		created() {
			this.$parent.footer('cart');
		},
	}
</script>

<style lang="less" scoped>
.external-link {
    width: 100%; /* 占满父容器宽度 */
    height: calc(100vh - 50px); /* 高度为视口高度减去顶部导航的高度 */
    border: none; /* 去掉边框 */
    overflow: auto; /* 确保 iframe 内部内容可以滚动 */
}
</style>